module.exports = __webpack_public_path__ + "static/240v_ac_relay_companion_module-fc1f2b52fcf5cbdfc2cfef64252409f1.png";